import IconAvatar from "common/components/IconAvatar";

import LeadListSourceTypeTag from "./LeadListSourceTypeTag";

import type { LeadListSource } from "../../types";

const MAX_COMPACT_SOURCES = 4;

interface LeadListSourcesTagProps {
  sources: LeadListSource[];
}

export default function LeadListSourcesTag({
  sources,
}: LeadListSourcesTagProps) {
  if (sources.length === 1) {
    return <LeadListSourceTypeTag type={sources[0].type} />;
  }

  const visibleSources = sources.slice(0, MAX_COMPACT_SOURCES);
  const overflowSources = sources.slice(MAX_COMPACT_SOURCES);

  return (
    <div className="flex flex-row -space-x-1">
      {visibleSources.map((source) => {
        const { id, type } = source;
        return <LeadListSourceTypeTag key={id} type={type} isCompact />;
      })}

      {!!overflowSources.length && (
        <IconAvatar
          size="xs"
          className="bg-black-100 text-black-700 ring-1 ring-black-200"
        >
          <span className="text-button-xxs">+{overflowSources.length}</span>
        </IconAvatar>
      )}
    </div>
  );
}
